import React from "react";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../analytics/googleAnalytics";

const languages = ["en", "fr", "de"];

const LangSelector = () => {
  const { i18n, t } = useTranslation();
  const currentLanguageCode = i18n.language?.split("-")[0];
  const selectedLanguage = languages.includes(currentLanguageCode)
    ? currentLanguageCode
    : "en";
  const selectedLanguageLabel = t(`common.languages.${selectedLanguage}`);

  const handleLanguageChange = (event) => {
    const nextLanguage = event.target.value;
    if (nextLanguage === selectedLanguage) {
      return;
    }
    i18n.changeLanguage(nextLanguage);
    trackEvent("language_changed", { language: nextLanguage });
  };

  return (
    <div
      className="relative flex items-center gap-1.5 px-1.5 py-2 text-StandardSEPM transition-colors duration-200 hover:text-[#cd5d48]"
      title={selectedLanguageLabel}
    >
      <Globe size={16} aria-hidden="true" className="transition-transform duration-200 hover:scale-105" />
      <label htmlFor="language-select" className="sr-only">
        {t("common.selectLanguage")}
      </label>
      <select
        id="language-select"
        value={selectedLanguage}
        onChange={handleLanguageChange}
        className="cursor-pointer appearance-none bg-transparent pr-4 text-sm font-semibold uppercase outline-none transition-colors duration-200 hover:text-[#cd5d48]"
      >
        {languages.map((languageCode) => (
          <option key={languageCode} value={languageCode}>
            {languageCode.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LangSelector;
